export const LIB_VERSION = '1.241.0'; // autogenerated
